import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/logo-white.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-46c20f20")

_pushScopeId("data-v-46c20f20")
const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-light container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "logo",
  alt: "logo"
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "font-weight-bold h4 ml-4 text-truncate"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-toggle": "collapse",
  "data-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("ul", { class: "navbar-nav mr-auto" }, null, -1)
const _hoisted_7 = { class: "btn" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Account Ledger ")
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fas fa-book" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "on-behalf-of"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "font-weight-bold" }, "On Behalf Of:", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fas fa-sign-out-alt" }, null, -1)
const _hoisted_13 = { class: "nav-item dropdown" }
const _hoisted_14 = {
  class: "nav-link",
  href: "#",
  id: "userOption",
  role: "button",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_16 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z"
  })
], -1)
const _hoisted_17 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "navbarDropdown"
}
const _hoisted_18 = {
  key: 0,
  class: "dropdown-item bg-success text-white"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Verified ")
const _hoisted_20 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M17 11C17.3 11 17.7 11 18 11.1V6.3L10.5 3L3 6.3V11.2C3 15.7 6.2 20 10.5 21C11.1 20.9 11.6 20.7 12.1 20.5C11.4 19.5 11 18.3 11 17C11 13.7 13.7 11 17 11M17 13C14.8 13 13 14.8 13 17S14.8 21 17 21 21 19.2 21 17 19.2 13 17 13M17 14.4C17.6 14.4 18.1 14.9 18.1 15.5C18.1 16.1 17.6 16.6 17 16.6S15.9 16.1 15.9 15.5 16.4 14.4 17 14.4M17 19.8C16.1 19.8 15.3 19.3 14.8 18.6C14.9 17.9 16.3 17.5 17 17.5S19.2 17.9 19.2 18.6C18.7 19.3 17.9 19.8 17 19.8Z"
  })
], -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Log out ")
const _hoisted_23 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M18,21L15,18L18,15V17H22V19H18V21M10,4A4,4 0 0,1 14,8A4,4 0 0,1 10,12A4,4 0 0,1 6,8A4,4 0 0,1 10,4M10,14C11.15,14 12.25,14.12 13.24,14.34C12.46,15.35 12,16.62 12,18C12,18.7 12.12,19.37 12.34,20H2V18C2,15.79 5.58,14 10,14Z"
  })
], -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "divider container" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("header", null, [
    _createVNode("nav", _hoisted_1, [
      _createVNode("div", null, [
        _createVNode(_component_router_link, { to: { name: 'dashboard' } }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: { name: 'on-behalf-of.home.manual.order' } }, {
          default: _withId(() => [
            (_ctx.user)
              ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, { to: { name: 'on-behalf-of.account.statement.report' } }, {
            default: _withId(() => [
              _hoisted_8,
              _hoisted_9
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createVNode("div", null, [
          (_ctx.user?.email)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(_ctx.user.email) + " ", 1),
                _createVNode(_component_router_link, { to: { name: 'dashboard' } }, {
                  default: _withId(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("a", _hoisted_14, [
            _createVNode("b", null, _toDisplayString(_ctx.userProfile.firstName), 1),
            _hoisted_15,
            _hoisted_16
          ]),
          _createVNode("div", _hoisted_17, [
            (_ctx.userProfile?.isActive)
              ? (_openBlock(), _createBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _hoisted_20
                ]))
              : _createCommentVNode("", true),
            _hoisted_21,
            _createVNode("a", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args))),
              class: "dropdown-item pointer"
            }, [
              _hoisted_22,
              _hoisted_23
            ])
          ])
        ])
      ])
    ]),
    _hoisted_24
  ]))
})